import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import useBlogCalls from "../../service/useBlogCalls";
import { useSelector } from "react-redux";
import { Box, Button, Stack, TextField, Typography } from "@mui/material";
import FavoriteIcon from "@mui/icons-material/Favorite";
import { MdVisibility } from "react-icons/md";
import { MdComment } from "react-icons/md";
import { Textarea } from "@mui/joy";
import moment from "moment/moment";

const BlogDetailed = () => {
  const { idx } = useParams();
  console.log(idx);
  const [comment, setComment] = useState("");
  const { getOneData, postLikeBlog, postComment } = useBlogCalls();
  const { data } = useSelector((state) => state.blog);
  const { token } = useSelector((state) => state.auth);
  const { user } = useSelector((state) => state.auth);
  // console.log("token", token);
  // console.log("userbilgisi", data);
  const [openComment, setOpenComment] = useState(true);
  const handleChange = (e) => {
    setComment(e.target.value);
  };
  const handleComment = () => {
    postComment({ blogId: data._id, comment: comment }, data._id);
    setComment("");
    console.log(data._id, comment);
  };

  useEffect(() => {
    getOneData("blogs", idx);
  }, []);
  // useEffect(()=>{
  //   getData()
  // },[data])

  return (
    <div className="blogDetail">
      <Stack
        className="blogDetailStack"
        style={{
          borderRadius: "10px",
          margin: "auto",
        
          color: "black",
          fontWeight: "bold",
          backgroundColor: "rgba(255,255,255,0.3)",
        }}
        justifyContent="center"
        alignItems="center"
        spacing={1}
      >
        {data && data.likes ? (
          <>
            <Box>
              <img
                src={data.image}
                alt=""
                style={
                  {"objectFit":"cover","objectPosition":"top","borderTopLeftRadius":"0.5rem","borderTopRightRadius":"0.5rem","width":"100%","height":"100%","boxShadow":"0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)","@media (min-width: 1024px)":{"borderRadius":"0.5rem"}}
                }
              />
            </Box>
            {/* <Typography style={{ textAlign: "left" }}></Typography> */}
            <div
              style={{
                width: "100%",
                padding: "2rem",
                paddingBottom: "1rem",
                marginTop: "1rem",
                marginBottom: "2rem",
                borderRadius: "0.5rem",
                backgroundColor: "rgba(255,255,255,0.8)",
                boxShadow:
                  "0 10px 15px -3px rgba(0,0,0,0.8), 0 4px 6px -2px rgba(0, 0, 0, 0.5)",
              }}
            >
              <Typography>
                User: {data.userId?.username} <br /> Created Time:{" "}
                {moment(data.createdAt).format("MMM Do YYYY")}{" "}
              </Typography>
              <Typography
                style={{ textAlign: "center", textTransform: "uppercase" }}
              >
                {data.title} <br />
              </Typography>
              <Typography style={{ boxSizing: "border-box", overflow: "auto" }}>
                {data.content}
              </Typography>
            </div>
            {/* <Stack
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              spacing={2}
            >
              <FavoriteIcon onClick={() => postLikeBlog(data._id)} />
              {data.likes && data.likes.length > 0 ? data.likes.length : 0}
              <MdComment onClick={() => setOpenComment(!openComment)} />

              <MdVisibility />
              {data.countOfVisitors}
            </Stack> */}
          </>
        ) : (
          <Typography>Loading...</Typography>
        )}
        <div
          style={{
            width: "100%",
            padding: "1rem",
            paddingLeft: "2rem",
            paddingRight: "2rem",
            paddingBottom: "1rem",
            marginBottom: "2rem",
            borderRadius: "0.5rem",
            backgroundColor: "rgba(255,255,255,0.8)",
            boxShadow:
              "0 10px 15px -3px rgba(0,0,0,0.8), 0 4px 6px -2px rgba(0, 0, 0, 0.5)",
          }}
        >
          <h3
            style={{
              paddingBottom: "1rem",
              marginBottom: "1rem",
              borderBottomWidth: "1px",
              fontSize: "1.25rem",
              lineHeight: "1.75rem",
              fontWeight: 600,
            }}
          >
            Leave a Reply
          </h3>
          <div
            style={{
              paddingBottom: "1rem",
              marginBottom: "2rem",
              borderBottomWidth: "1px",
              fontSize: "1.25rem",
              lineHeight: "1.75rem",
              fontWeight: 600,
            }}
          >
            <textarea
              value={comment}
              onChange={handleChange}
              style={{
                padding: "1rem",
                borderRadius: "0.5rem",
                outlineStyle: "none",
                width: "100%",
                height: "10rem",
                backgroundColor: "#F3F4F6",
              }}
              name="comment"
              placeholder="Comment"
            />
            <div style={{ marginTop: "2rem" }}>
              <button
                // disabled={!user.token}
                type="button"
                onClick={handleComment}
                style={{
                  display: "inline-block",
                  paddingTop: "0.75rem",
                  paddingBottom: "0.75rem",
                  paddingLeft: "2rem",
                  paddingRight: "2rem",
                  borderRadius: "9999px",
                  fontSize: "1.125rem",
                  lineHeight: "1.75rem",
                  fontWeight: 500,
                  color: "#ffffff",
                  backgroundColor: "#DB2777",
                  transition: "background-color 0.3s ease",
                  cursor: "pointer",
                }}
                onMouseOver={(e) => {
                  e.target.style.backgroundColor = "#312E81";
                }}
                onMouseOut={(e) => {
                  e.target.style.backgroundColor = "#DB2777";
                }}
              >
                Post Comment
              </button>
            </div>
          </div>
        </div>
        {/* {openComment && (
          <div>
            {data && data.comments
              ? data.comments.map((item, i) => (
                  <Stack
                    mt={3}
                    style={{
                      border: "1px solid black",
                      padding: "10px",
                      borderRadius: "10px",
                    }}
                    key={i}
                  >
                    <Typography>User : {item?.userId.username}</Typography>
                    <Typography>
                      {" "}
                      Time : {new Date(item.createdAt).toLocaleString()}
                    </Typography>

                    <Typography>{item.comment}</Typography>
                  </Stack>
                ))
              : undefined}
          </div>
        )} */}
        <div
          style={{
            padding: "2rem",
            paddingBottom: "3rem",
            marginBottom: "2rem",
            borderRadius: "0.5rem",
            backgroundColor: "#ffffff",
            width: "100%",
            boxShadow:
              "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
          }}
        >
          <h3
            style={{
              paddingBottom: "1rem",
              marginBottom: "2rem",
              borderBottomWidth: "1px",
              borderBottomColor: "#DB2777",
              fontSize: "1.25rem",
              lineHeight: "1.75rem",
              fontWeight: "600",
              color: "#DB2777",
            }}
          >
            {data.comments && data.comments.length} Comments
          </h3>
          {data.comments
            ? data.comments.map((comment, index) => (
                <div
                  key={index}
                  style={{
                    paddingBottom: "1rem",
                    marginBottom: "1rem",
                    borderBottomWidth: "1px",
                    borderBottomColor: "#DB2777",
                    borderColor: "#F3F4F6",
                  }}
                >
                  <p style={{ marginBottom: "1rem", fontSize: ".8rem" }}>
                    <span style={{ fontWeight: 400, fontStyle: "italic" }}>
                      {comment.userId.username}
                    </span>{" "}
                    on {moment(comment?.createdAt).format("MMM Do, YYYY")}
                  </p>
                  <p
                    style={{
                      width: "100%",
                      color: "#4B5563",
                      whiteSpace: "pre-line",
                    }}
                  >
                    {comment?.comment}
                  </p>
                </div>
              ))
            : undefined}
        </div>
      </Stack>
    </div>
  );
};

export default BlogDetailed;
